<template>
  <div style="margin: 10px; height: 600px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="科目代码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input
          v-model="options.km_dm"
          placeholder="科目代码"
          v-bind:disabled="kmdm_dis"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="科目名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.km_mc" placeholder="科目名称"></v-input>
      </v-form-item>
      <v-form-item 
        label="使用部门"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-radio-group v-model="options.sybm" :data="sybm_options"></v-radio-group>
      </v-form-item>
      <v-form-item
        label="备注"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.km_ms" placeholder="备注"></v-input>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xy_bz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  km_dm: "",
  km_mc: "",
  km_ms: "",
  sybm:"1",
  xy_bz: true,
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options,
      kmdm_dis: false,
      sybm_options: [
      { text: "本部", value: "1" },
      { text: "客户", value: "2" }
    ],
    };
  },
  created() {
    if (this.$route.query.km_dm) {
      this.init();
      this.kmdm_dis = true;
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/bxkm/get-bxkm-first?km_dm=" + this.$route.query.km_dm)
        .then((res) => {
          this.options = res.data;
          if (res.data.xy_bz == 1) {
            this.options.xy_bz = true;
          } else {
            this.options.xy_bz = false;
          }
        });
    },
    save() {
      if(!this.options.km_dm){
        this.$message["error"]("请输入科目代码");
        return;
      }
      if(!this.options.km_mc){
        this.$message["error"]("请输入科目名称");
        return;
      }
      if (this.options.xy_bz) {
        this.options.xy_bz = "1";
      } else {
        this.options.xy_bz = "0";
      }
      if (this.$route.query.km_dm) {
        this.$axios
          .post("api/system/bxkm/update-bxkm-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      } else {
        this.$axios
          .post("api/system/bxkm/set-bxkm-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/bxkmwhadd.vue